import moment from 'moment';
import intl from 'react-intl-universal';
import {
  Button,
  Icon,
  Typography,
  tailwindOverride,
  useElevation,
} from '@getsynapse/design-system';
import { DATE } from 'utils/constants';
import UnarchiveIcon from 'assets/icons/unarchive.svg';

type ArchivedProgramBannerProps = {
  archiveDate: string;
  canUnarchive: boolean;
  onUnarchiveClick: () => void;
};

const ArchivedProgramBanner = ({
  archiveDate,
  canUnarchive,
  onUnarchiveClick,
}: ArchivedProgramBannerProps) => {
  const elevation = useElevation(2);

  return (
    <div
      className={`mb-6 rounded-sm ${elevation}`}
      data-testid='program-archived-banner'
    >
      <div className='shadow-archived-banner py-4 px-6 flex'>
        <Icon name='archive' className='text-purple-dark w-6 h-6' />
        <div className='flex justify-between w-full gap-4'>
          <div className='ml-4'>
            <Typography variant='h6'>
              {intl.get('PROGRAM_PAGE.ARCHIVED_PROGRAM_BANNER.TITLE')}
            </Typography>
            <Typography>
              {intl.get('PROGRAM_PAGE.ARCHIVED_PROGRAM_BANNER.BODY', {
                archiveDate: moment(archiveDate).format(DATE.SHORT_FORMAT),
              })}
            </Typography>
          </div>
          <div className='flex-shrink-0'>
            {canUnarchive && (
              <Button
                variant='secondary'
                iconSrc={UnarchiveIcon}
                className={tailwindOverride(
                  'text-purple-darker border-purple-lighter leading-6',
                  'hover:bg-purple-darker hover:border-purple-darker',
                  'focus-visible:bg-purple-darker focus-visible:border-purple-darker',
                  'active:bg-purple-darker active:border-purple-darker'
                )}
                data-cy='unarchive-program-button'
                onClick={onUnarchiveClick}
              >
                {intl.get('PROGRAM_PAGE.ARCHIVED_PROGRAM_BANNER.BUTTON')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchivedProgramBanner;
